export default __webpack_public_path__ + "static/media/hht1_ep07_timeline_q02_b.48878cb6.png";